import { useState, useEffect } from 'react';
import {
    createProductCategoriesDetail,
    deleteProductCategoriesDetail,
    getProductsCategoriesDetail,
    updateProductCategoriesDetail
} from '../services/ProductDetailCategoriesService';

export const useProductCategoriesDetails = () => {

    const [productDetails, setProductDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchProductCategoriesDetails = async () => {
        setLoading(true);
        try {
            const response = await getProductsCategoriesDetail();
            setProductDetails(response.data);
        } catch (err) {
            setError('Failed to fetch products');
        } finally {
            setLoading(false);
        }
    };

    const addProductCategoriesDetails = async (productDetails) => {
        try {
            const response = await createProductCategoriesDetail(productDetails);
            setProductDetails([...productDetails, response.data]);
        } catch {
            setError('Failed to add productDetails');
        }
    };

    const editProductCategoriesDetails = async (id, updatedProductDetails) => {
        try {
            const response = await updateProductCategoriesDetail(id, updatedProductDetails);
            setProductDetails(productDetails.map(p => (p.id === id ? response.data : p)));
        } catch {
            setError('Failed to update Product Details');
        }
    };

    const removeProductCategoriesDetails = async (id) => {
        try {
            await deleteProductCategoriesDetail(id);
            setProductDetails(productDetails.filter(p => p.id !== id));
        } catch {
            setError('Failed to delete product');
        }
    };

    useEffect(() => {
        fetchProductCategoriesDetails();
    }, []);

    return {
        loading,
        error,
        fetchProductCategoriesDetails,
        removeProductCategoriesDetails,
        editProductCategoriesDetails,
        addProductCategoriesDetails
    };

};
